export enum ProminentPriceChoices {
  YEARLY,
  MONTHLY,
}
